// src/data/masterclass.ts - Contenido de la landing "Masterclass gratuita"

// Fecha/hora de la clase (hora Perú, UTC-5). Editar aquí para cambiar la próxima fecha
// — la usan tanto la página /masterclass como el slide promocional del carrusel del Home.
export const MASTERCLASS_DATETIME = '2026-09-06T20:00:00-05:00';

export interface MethodPillar {
  letter: string;
  tag: string;
  title: string;
  description: string;
}

export const methodPillars: MethodPillar[] = [
  {
    letter: 'W',
    tag: 'work',
    title: 'Entiende tu trabajo',
    description: 'Identifica qué tareas y procesos podrían mejorarse con IA.',
  },
  {
    letter: 'I',
    tag: 'intelligence',
    title: 'Trabaja correctamente con IA',
    description: 'Dale contexto, información e instrucciones para mejores resultados.',
  },
  {
    letter: 'T',
    tag: 'tools',
    title: 'Elige las herramientas',
    description: 'Usa la tecnología adecuada según lo que necesitas resolver.',
  },
  {
    letter: 'S',
    tag: 'systems',
    title: 'Construye procesos',
    description: 'Transforma tareas aisladas en procesos apoyados por IA.',
  },
];

export interface BentoItem {
  number: string;
  eyebrow: string;
  title: string;
  description: string;
  image?: string;
  imageAlt?: string;
  imageSide?: 'left' | 'right';
}

export const bentoItems: BentoItem[] = [
  {
    number: '01',
    eyebrow: 'Identifica',
    title: 'Detecta dónde estás perdiendo tiempo',
    description:
      'Reconoce tareas repetitivas, administrativas, de análisis, investigación, organización o creación que podrían mejorarse con IA.',
    image: '/images/06-masterclass/masterclass-3.jpeg',
    imageAlt: 'Analizar tareas para identificar oportunidades con IA',
    imageSide: 'right',
  },
  {
    number: '02',
    eyebrow: 'Aplica',
    title: 'Mejores resultados con IA',
    description:
      'Una estructura práctica para dar contexto, información e instrucciones claras y conseguir resultados útiles.',
  },
  {
    number: '03',
    eyebrow: 'Elige',
    title: 'La herramienta adecuada',
    description: 'No necesitas decenas de herramientas: piensa primero en el problema y luego elige la tecnología.',
  },
  {
    number: '04',
    eyebrow: 'Sistematiza',
    title: 'Pasa de tareas aisladas a procesos',
    description:
      'Entiende la diferencia entre usar IA, trabajar con IA y construir procesos apoyados por Inteligencia Artificial.',
    image: '/images/06-masterclass/masterclass-4.jpeg',
    imageAlt: 'Procesos apoyados por Inteligencia Artificial',
    imageSide: 'left',
  },
];

export const forYouChecklist: string[] = [
  'Ya usas IA, pero sientes que la aprovechas de forma básica.',
  'Pierdes tiempo en tareas repetitivas que podrían ser más eficientes.',
  'Escuchas de nuevas herramientas y no sabes cuáles necesitas.',
  'Quieres incorporar IA sin convertirte en programador.',
  'Quieres mejorar tu productividad y actualizar tu forma de trabajar.',
  'Te interesa que una tarea evolucione hacia un proceso apoyado por IA.',
];

export interface BeforeAfter {
  before: string;
  after: string;
}

export const beforeAfterPairs: BeforeAfter[] = [
  {
    before: '"Le hago preguntas a ChatGPT."',
    after: '"Sé darle contexto e instrucciones para obtener mejores resultados."',
  },
  {
    before: '"Conozco algunas herramientas, pero no sé cuál usar."',
    after: '"Sé elegir una herramienta según el problema a resolver."',
  },
  {
    before: '"Utilizo IA para tareas aisladas."',
    after: '"Entiendo cómo integrarla dentro de mis procesos de trabajo."',
  },
];

export interface NextStep {
  number: string;
  label: string;
  title: string;
  description: string;
}

export const nextSteps: NextStep[] = [
  { number: '1', label: 'paso 01', title: 'Regístrate', description: 'Completa tus datos en el formulario.' },
  {
    number: '2',
    label: 'paso 02',
    title: 'Únete al grupo',
    description: 'Al finalizar, ingresa al grupo privado de WhatsApp.',
  },
  {
    number: '3',
    label: 'paso 03',
    title: 'Conéctate',
    description: 'Recibirás los recordatorios y el acceso a la clase en vivo.',
  },
];

export interface FaqItem {
  question: string;
  answer: string;
}

export const faqItems: FaqItem[] = [
  {
    question: '¿Necesito saber de programación o IA?',
    answer:
      'No. La clase está pensada para empezar desde cero: aprenderás a aplicar IA en tu trabajo sin conocimientos técnicos previos.',
  },
  {
    question: '¿La clase tiene costo?',
    answer: 'Es 100% gratuita y en vivo. Solo necesitas registrarte para reservar tu lugar; los cupos son limitados.',
  },
  {
    question: '¿Cómo accedo a la clase?',
    answer:
      'Al registrarte, te unes a un grupo privado de WhatsApp donde enviamos los recordatorios y el enlace de acceso a la clase en vivo.',
  },
  {
    question: '¿Habrá grabación?',
    answer:
      'La experiencia está diseñada para vivirse en vivo e interactuar en tiempo real. Te recomendamos conectarte a la hora indicada para aprovecharla al máximo.',
  },
];

// NOTA: NO reemplazar por testimonios inventados. Sustituir solo por
// testimonios reales autorizados por Infinity Wits.
export interface TestimonialPlaceholder {
  id: number;
}

export const testimonialPlaceholders: TestimonialPlaceholder[] = [{ id: 1 }, { id: 2 }, { id: 3 }];
